// What this app is CALLED, everywhere a human can read it.
//
// ⚠️ THE PLATFORM IS WHITE-LABELLED. "Ironside" is the platform we build on; it is
// not the product these people were sold. To a Creator, a Brand, or anyone at YWS,
// this is the YWS Creator Scripts app and nothing else. The name must not leak —
// not into a page title, not into a browser tab, not into a Slack button, not into
// an error message someone screenshots into a channel with a brand in it.
//
// That is why the name lives HERE and is imported, rather than being typed out at
// each site. It leaked in six places at once (both auth pages, the tab title, the
// access-pending screen and the bot's sign-in button) precisely because each one
// was written on its own, months apart, by someone who never saw the other five.
// A grep is not a design. One import is.
//
// `ironside-*` FILENAMES, module names, localStorage keys and env vars are mostly
// fine and deliberately untouched — nobody sees them, and renaming them would be a
// large diff that protects nothing.
//
// ONE EXCEPTION, and it is not obvious: a CLIENT component's file path and export
// name are serialized into the RSC payload, in the HTML. `components/
// ironside-sidebar.tsx` / `IronsideSidebar` was sitting in the source of every
// signed-out page — view-source being exactly where a curious brand would look. It
// is `app-sidebar.tsx` / `AppSidebar` now. Keep the platform's name out of any
// "use client" module's path or exports; a server module is not visible this way
// and does not matter.

/** The product, as every user knows it. Never "Ironside". */
export const PRODUCT_NAME = "Creator Scripts";

/** Who runs it. The sidebar pairs this with PRODUCT_NAME. */
export const ORG_NAME = "YWS Agency";

/**
 * The line under the wordmark on the signed-out pages, and the page description.
 *
 * It used to read "AI-first agency operations" — which is the PLATFORM's pitch to
 * an agency, aimed at a buyer who is not the person reading this. The people who
 * see this string are creators signing in to write scripts.
 */
export const PRODUCT_TAGLINE = "Scripts and briefs for YWS creators";
